// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type TagIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from tag.svg
 */
export default function TagIcon(props: TagIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="TagIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M7 0a1 1 0 0 1 .563.174l.096.073 8 7a1 1 0 0 1 .222 1.227l-.067.107-5 7a1 1 0 0 1-1.38.244l-.098-.078-9-8a1 1 0 0 1-.329-.626L0 7V1A1 1 0 0 1 .883.007L1 0zm-.376 2H2v4.551l7.833 6.962 3.826-5.358zM7 5a2 2 0 1 0-4 0 2 2 0 0 0 4 0"
        />
      </g>
    </svg>
  );
}
